class FeatureIconsSlider {
  constructor () {
    this.slider = null;
    this.load();
  }

  load () {
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });
  }

  init () {
    this.initMainSlider();
  }

  initMainSlider () {
     let length = document.querySelectorAll(".js-feature-icons .swiper-slide").length;
    this.slider = new Swiper(".js-feature-icons", {
      spaceBetween: 30,
      grabCursor: true,
      a11y: false,
      freeMode: true,
      speed: 11000,
      loop: true,
      slidesPerView: "auto",
      autoplay: {
        delay: 0.5,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
        },
        1024: {
          slidesPerView: length,
        }
      }
    });
  }
}
new FeatureIconsSlider();
